import React from 'react';
import Image from '../Image/image-component';
import { ButtonBlack } from '../Buttons/button-component';

const EntryCard = ({ entry, primaryImageKey, onEdit, onDelete, onClone, disabled, disableDelete, strings }) => {
    const mediaUrl = entry[primaryImageKey];
    const isVideo = mediaUrl?.toLowerCase().match(/\.(mp4|webm|mov)$/);
    const title = entry.name || entry.title || entry.cardTitle || 'Untitled';
    
    // Core Active State Logic
    const isActive = entry.isActive !== undefined ? entry.isActive : entry.status;

    const formatValue = (v) => {
        if (v === null || v === undefined || v === "") return '—';
        if (Array.isArray(v)) return `${v.length} Items`;
        if (typeof v === 'object') return '{...}';
        return String(v);
    };

    return (
        <div className={`group relative bg-white dark:bg-neutral-900 rounded-2xl border border-neutral-100 dark:border-neutral-800 p-3 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col h-full ${!isActive ? 'opacity-70' : ''}`}>
            
            {/* --- UTILITY OVERLAY --- */}
            <div className="absolute top-6 right-6 z-20 flex flex-col gap-2 opacity-0 group-hover:opacity-100 transition-all duration-200">
                <button 
                    onClick={() => onClone(entry)} 
                    className="p-2 bg-white dark:bg-neutral-800 rounded-lg shadow-lg border border-neutral-200 dark:border-neutral-700 hover:text-blue-600 transition-all text-neutral-500"
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2" /></svg>
                </button>
                <button 
                    disabled={disableDelete} 
                    onClick={() => onDelete(entry.id)} 
                    className="p-2 bg-white dark:bg-neutral-800 rounded-lg shadow-lg border border-neutral-200 dark:border-neutral-700 hover:text-red-500 transition-all text-neutral-400 disabled:opacity-10"
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
                </button>
            </div>

            {/* --- MEDIA AREA --- */}
            <div className={`relative aspect-video rounded-xl overflow-hidden bg-neutral-100 dark:bg-neutral-800 shrink-0 transition-all duration-500 ${!isActive ? 'grayscale' : ''}`}>
                {mediaUrl && mediaUrl !== "" ? (
                    isVideo ? (
                        <video src={mediaUrl} autoPlay muted loop playsInline className="w-full h-full object-cover" />
                    ) : (
                        <Image 
                            src={mediaUrl} 
                            wrapperClassName="absolute inset-0 w-full h-full" 
                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" 
                        />
                    )
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-[10px] font-bold text-neutral-400 italic">EMPTY</div>
                )}
             
            </div>

            {/* --- INFO AREA --- */}
            <div className="p-4 flex flex-col flex-grow">
                <div className="mb-4">
                    <h3 className={`text-lg font-bold text-neutral-900 dark:text-white truncate mb-1 ${!isActive ? 'text-neutral-500' : ''}`}>
                        {title}
                    </h3>
                </div>

                {/* --- DATA GRID --- */}
                <div className="grid grid-cols-2 gap-y-4 gap-x-6 mb-6 pt-4 border-t border-neutral-100 dark:border-neutral-800 flex-grow">
                    {Object.entries(entry).slice(0, 8).map(([k, v]) => {
                        if (['id', 'isActive', 'status', primaryImageKey, 'name', 'title', 'cardTitle', 'slug', 'seo', 'hero'].includes(k)) return null;
                        
                        return (
                            <div key={k} className="flex flex-col min-w-0">
                                <span className="text-[10px] font-normal text-neutral-400  mb-0.5 truncate">{k.split(/(?=[A-Z])/).join(" ")}</span>
                                <span className="text-[14px] font-bold text-neutral-800 dark:text-neutral-200 truncate">
                                    {formatValue(v)}
                                </span>
                            </div>
                        );
                    })}
                </div>

                <ButtonBlack 
                    onClick={() => onEdit(entry)} 
                    className="w-full !rounded-xl !py-3 !text-[12px] font-bold transition-all active:scale-[0.98]"
                >
                    Edit Record
                </ButtonBlack>
            </div>
        </div>
    );
};

export default EntryCard;